import {CURRENCY_CZK} from '@dms/shared';

export const DEFAULT_CURRENCY_CODE = CURRENCY_CZK;
